<template>
    <a-modal v-model:open="showChangeCoverDateModal" title="Change Cover Date" :destroyOnClose="true">
        <template #footer>
            <a-button data-cy="cancel-cover-date" @click="hideModal">
                {{ $t('globals.buttons.cancel') }}
            </a-button>
            <a-button data-cy="button-save" type="primary" :loading="loading" @click="handleSubmit">
                {{ $t('globals.buttons.save') }}
            </a-button>
        </template>

        <form @submit.prevent="handleSubmit">
            <div class="form-section">
                <div class="section-body">
                    <div class="flex justify-start gap-36 w-full">
                        <ui-label class="block" data-cy="effective-date-label">Effective Date</ui-label>
                        <ui-label class="block" data-cy="expiry-date-label">Expiry Date</ui-label>
                    </div>

                    <ui-date-range-picker-double
                        v-model="cover_dates"
                        :date_limits="{ start_date: todayStart }"
                        section="cover"
                    />

                    <div class="flex justify-start gap-36 w-full">
                        <span
                            v-if="v$.cover_dates.start_date.required.$invalid && v$.cover_dates.start_date.$error"
                            class="text-default-red"
                            data-cy="effective-date-required-error"
                        >
                            {{ $t('validation.required') }}
                        </span>

                        <span
                            v-if="v$.cover_dates.end_date.required.$invalid && v$.cover_dates.end_date.$error"
                            class="text-default-red"
                            data-cy="expiry-date-required-error"
                        >
                            {{ $t('validation.required') }}
                        </span>
                    </div>
                </div>
            </div>
        </form>
    </a-modal>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import UiDateRangePickerDouble from '@/components/ui/DateRangePickerDouble.vue';
import UiLabel from '@/components/ui/Label.vue';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiDateRangePickerDouble,
        UiLabel,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showChangeCoverDateModal: false,
            processing: false,
            cover_dates: {
                start_date: null,
                end_date: null,
            },
        };
    },
    validations: {
        cover_dates: {
            start_date: { required },
            end_date: { required },
        },
    },
    computed: {
        todayStart() {
            return this.$dayjs().startOf('day');
        },
    },
    methods: {
        openModal() {
            this.cover_dates.start_date = this.$dayjs();
            this.cover_dates.end_date = this.$dayjs().add(1, 'year');
            this.showChangeCoverDateModal = true;
        },
        hideModal() {
            this.showChangeCoverDateModal = false;
        },
        async handleSubmit() {
            if (!(await this.v$.$validate())) return false;

            this.$emit('submitCoverDate', this.cover_dates);
        },
    },
};
</script>
